module.exports = __webpack_public_path__ + "static/img/download.5a3bba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/fileIcon/download.png
// module id = iro+
// module chunks = 4